import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';

const ContactCard = () => {
  const theme = useTheme();

  return (
    <Box
      component={Card}
      boxShadow={0}
      border={`1px solid ${theme.palette.divider}`}
    >
      <Box padding={{ xs: 2, sm: 3 }}>
        <Typography
          sx={{
            fontWeight: '700',
          }}
          gutterBottom
        >
          ¿Cómo puede contactarnos?
        </Typography>
        <Typography
          variant={'body2'}
          color={'text.secondary'}
          sx={{
            marginBottom: 2,
          }}
        >
          Si tienes alguna duda sobre nuestras políticas de privacidad,
          escribenos.
        </Typography>
        <Typography variant={'subtitle2'}>
          info@hauscanner.com
          <br />
          Barranquilla, Atlántico
          <br />
          Colombia
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactCard;
